import { render } from "./Vision_working_group_Questions.vue?vue&type=template&id=710d0aaa&scoped=true"
import script from "./Vision_working_group_Questions.vue?vue&type=script&lang=js"
export * from "./Vision_working_group_Questions.vue?vue&type=script&lang=js"

import "./Vision_working_group_Questions.vue?vue&type=style&index=0&id=710d0aaa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710d0aaa"]])

export default __exports__